import { render, staticRenderFns } from "./FacilityComplaintsList.vue?vue&type=template&id=9e3cc572&scoped=true&"
import script from "./FacilityComplaintsList.vue?vue&type=script&lang=js&"
export * from "./FacilityComplaintsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3cc572",
  null
  
)

export default component.exports